var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3171 56.6829C12.7285 54.0942 14.4454 48.6595 13.1278 45.4751C11.762 42.1739 6.75 39.517 6.75 35.9999C6.75 32.4828 11.762 29.826 13.1279 26.5249C14.4455 23.3404 12.7285 17.9058 15.3171 15.3171C17.9057 12.7285 23.3405 14.4454 26.5249 13.1278C29.8261 11.762 32.483 6.75 36.0001 6.75C39.5172 6.75 42.174 11.762 45.4751 13.1279C48.6595 14.4455 54.0942 12.7285 56.6829 15.3171C59.2715 17.9057 57.5546 23.3405 58.8722 26.5249C60.238 29.8261 65.25 32.483 65.25 36.0001C65.25 39.5172 60.238 42.174 58.8721 45.4751C57.5546 48.6595 59.2715 54.0942 56.6829 56.6829C54.0943 59.2715 48.6595 57.5546 45.4751 58.8722C42.1739 60.238 39.517 65.25 35.9999 65.25C32.4828 65.25 29.826 60.238 26.5249 58.8721C23.3404 57.5546 17.9058 59.2715 15.3171 56.6829Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3171 56.6829C12.7285 54.0942 14.4454 48.6595 13.1278 45.4751C11.762 42.1739 6.75 39.517 6.75 35.9999C6.75 32.4828 11.762 29.826 13.1279 26.5249C14.4455 23.3404 12.7285 17.9058 15.3171 15.3171C17.9057 12.7285 23.3405 14.4454 26.5249 13.1278C29.8261 11.762 32.483 6.75 36.0001 6.75C39.5172 6.75 42.174 11.762 45.4751 13.1279C48.6596 14.4455 54.0942 12.7285 56.6829 15.3171C59.2715 17.9057 57.5546 23.3405 58.8722 26.5249C60.238 29.8261 65.25 32.483 65.25 36.0001C65.25 39.5172 60.238 42.174 58.8721 45.4751C57.5545 48.6596 59.2715 54.0942 56.6829 56.6829C54.0943 59.2715 48.6595 57.5546 45.4751 58.8722C42.1739 60.238 39.517 65.25 35.9999 65.25C32.4828 65.25 29.826 60.238 26.5249 58.8721C23.3404 57.5545 17.9058 59.2715 15.3171 56.6829Z",
    stroke: "black",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.375 29.25L31.8749 45L23.625 37.125",
    stroke: "black",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimple);
export default __webpack_public_path__ + "static/media/simple.cd4e2031219035d625b9afb435fe4a0b.svg";
export { ForwardRef as ReactComponent };